import { Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';
import { useLeaseQuery } from '../../../utils/queries';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function YourUpcomingLeaseTermWillBeMonthToMonth() {
  const { leaseId } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId);

  const lease = leaseQuery?.data;
  const endDate = lease?.getLeasePackageFriendlyEndDate();

  return (
    <>
      <Icon size="lg" role="img" css={{ marginBottom: 'loose' }}>
        <IconHandshakeFilled />
      </Icon>
      <Heading level={2} fontFamily="heading-alt" css={{ textStyle: 'responsive.heading-md', marginBottom: 'loose' }}>
        Your upcoming lease term will be month-to-month
      </Heading>
      {endDate ? (
        <Paragraph>
          After your lease term ends on <strong>{endDate}</strong>, your next term will automatically convert to
          month-to-month unless you end the lease.
        </Paragraph>
      ) : (
        <Paragraph>
          After your lease term ends, your next term will automatically convert to month-to-month unless you end the
          lease.
        </Paragraph>
      )}
    </>
  );
}
